/**
 * Project : workspace
 * File    : LoginScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.common.auth


import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import appConfig.AppConfig
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import common.asset.ImageAsset
import component.CustomDefaultBtn
import component.ErrorSuggestion
import component.country.DialCodeHelper
import component.input.CheckBoxInput
import component.input.MobileTextField
import component.loader.AppLoader
import component.navigation.TopNavBar
import locale.localization
import navigation.AppNavigator
import navigation.route.auth.AuthNavRoute
import navigation.route.policy.PolicyNavRoute
import theme.ThemeColor

/**
 * Represents the login screen class.
 */

class LoginScreen {
    @Composable
    fun Content() {
        val viewModel = AuthViewModel()
        val mobileNumber = viewModel.mobileNumber.collectAsState()
        var dialCode by remember { mutableStateOf(DialCodeHelper().getSelectedCountryCode()) }
        viewModel.goToHome = {
            viewModel.hideAuthContainer()
        }
        viewModel.goBack = {
            AppNavigator.shared().authController?.popBackStack()
        }
        viewModel.goToRegister = {
            AuthHandler.shared().dialCode = dialCode.countryPhoneCode
            AppNavigator.shared().authController?.navigate(AuthNavRoute.REGISTER)
        }
        viewModel.goToSetMPin = {
            AuthHandler.shared().dialCode = dialCode.countryPhoneCode
            AppNavigator.shared().authController?.navigate(AuthNavRoute.SET_MPIN)
        }
        viewModel.goToLoginWithMPin = {
            AuthHandler.shared().dialCode = dialCode.countryPhoneCode
            AppNavigator.shared().authController?.navigate(AuthNavRoute.VERIFY_MPIN)
        }
        viewModel.goToOtp = {
            AuthHandler.shared().dialCode = dialCode.countryPhoneCode
            AppNavigator.shared().authController?.navigate(AuthNavRoute.VERIFY_OTP)
        }

        val isTerms = remember { mutableStateOf(true) }

        var isValidMobile by remember { mutableStateOf(false) }

        val mobileErrorState = remember {
            mutableStateOf(false)
        }

        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(0.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            TopNavBar(
                localization().accountAuthentication.signIn,

//                onBackPress = { AppNavigator.shared().authController?.popBackStack() }
            )
            AppLoader(viewModel)
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(8.dp),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Spacer(modifier = Modifier.height(20.dp))
                Text(
                    text = localization().accountAuthentication.welcomeTo + AppConfig().appName,
                    fontSize = 26.sp,
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.padding(start = 30.dp, end = 30.dp)
                )
                Text(
                    text = localization().accountAuthentication.signInScreenText,
                    color = ThemeColor.shared().TextColor,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.padding(start = 30.dp, end = 30.dp, top = 12.dp)
                )
                Spacer(modifier = Modifier.height(50.dp))
                MobileTextField(
                    mobileNumber = mobileNumber.value,
                    placeholder = "9000000000",
                    trailingIcon = ImageAsset.phone,
                    label = localization().accountAuthentication.mobileNumber,
                    errorState = mobileErrorState,
                    visualTransformation = VisualTransformation.None,
                    onChanged = { mob ->
                        viewModel.setMobileNumber(mob.text)
                        isValidMobile = (mob.text.length in 9..11)
                    },
                    onDialCodeChange = {
                        dialCode = it
                    }
                )

                Spacer(modifier = Modifier.height(10.dp))
                if (mobileErrorState.value) {
                    ErrorSuggestion("Please enter valid mobile number")
                }

                Spacer(modifier = Modifier.height(20.dp))
                CheckBoxInput("Terms and Policies",isTerms.value){
                    isTerms.value = it
                }
                Row(modifier = Modifier
                    .fillMaxWidth()
                    .height(40.dp)
                    .clickable(
                        onClick = {
                            AuthViewModel().hideAuthContainer()
                            AppNavigator.shared().navigate(PolicyNavRoute.HOME)
                        }
                    )
                    .padding(8.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Text(text = "link")
                }

                CustomDefaultBtn(
                    shapeSize = 50f,
                    btnText = localization().accountAuthentication.continueButton,
                    isEnabled = isTerms.value
                ) {
                    mobileErrorState.value = !isValidMobile
                    if (isValidMobile) {
                        viewModel.checkAccount(mobileNumber.value, dialCode.countryPhoneCode){
                            print(it)
                        }
                    }
                }
            }
        }
    }
}


